import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import apiClient from "../apiClient";
import { isAuthenticated, setAuthSession } from "../auth.js";

const Login = () => {
  const [values, setValues] = useState({ UserName: "", Password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await apiClient.post("/auth/login", values);
      setAuthSession({
        token: res.data?.token,
        user: res.data?.user,
        entities: res.data?.entities || [],
        entityId: res.data?.entity?.EntityID,
      });
      window.location.href = "/";
    } catch (err) {
      setError("Invalid username or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Sign In</h1>
          <p className="page-subtitle">Enter your account credentials.</p>
        </div>
      </header>

      <section className="panel form-card">
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="login-username">Username</label>
          <input
            id="login-username"
            type="text"
            value={values.UserName}
            onChange={(e) => setValues((prev) => ({ ...prev, UserName: e.target.value }))}
            autoComplete="username"
          />

          <label htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            value={values.Password}
            onChange={(e) => setValues((prev) => ({ ...prev, Password: e.target.value }))}
            autoComplete="current-password"
          />

          <div className="form-actions">
            <button className="btn" type="submit" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </div>

          {error && <p className="notice notice-error">{error}</p>}
        </form>
      </section>
    </div>
  );
};

export default Login;
